import React from 'react';

export const name = 'announcement';

export const Announcement = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color="#161619"
  >
    <path
      d="M3.99756 5.72239V17.7674L8.58006 15.0374L20.0026 21.2324V2.45239L8.58006 8.53489L3.99756 5.72239Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M10.9501 16.5974L9.68262 19.3649L13.8901 21.5474L15.1651 18.7799"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M8.58008 8.53491V15.0374"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
  </svg>
);
